export const COLORS = [
  '#3b82f6', // blue
  '#10b981', // green
  '#f59e0b', // amber
  '#8b5cf6', // purple
  '#ef4444', // red
  '#06b6d4', // cyan
  '#ec4899', // pink
  '#f97316', // orange
  '#14b8a6', // teal
  '#a855f7', // violet
];

/** Stable colour of a category: its position in `categories`, cycling through the palette. */
export function getColorForCategory(category: string, categories: string[]): string {
  const index = categories.indexOf(category);
  return index >= 0 ? COLORS[index % COLORS.length] : COLORS[0];
}
